import { FC, useContext } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import TopSpecialtiesTable from "../components/TopSpecialtiesTable";
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "../../../shared/waffles";

interface TopSpecialtiesDrillInData {
  [wafflesKeyColumnName]: string;
  specialtyGroupName: string;
  fillableGapCount: string;
  unfillableGapCount: string;
}

const columnConfig: ColumnConfig = {
  fillableGapCount: {
    displayText: "Composite Fillable Gaps",
    noSort: true,
    style: { fontSize: "10px" },
    testId: "fillable-gaps",
  },
  specialtyGroupName: {
    displayText: "Specialty",
    noSort: true,
    style: { fontSize: "10px" },
    testId: "specialty-name",
  },
  unfillableGapCount: {
    displayText: "Unfillable Gaps",
    noSort: true,
    style: { fontSize: "10px" },
    testId: "unfillable-gaps",
  },
}

const TopSpecialtiesByGapExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Top 10 Specialites by Gap Count";

  const tableData = wizardContext.gapsBySpecialtyData.map((row) => {
    return {
      /* eslint-disable sort-keys */
      [wafflesKeyColumnName]: row.specialtyGroupId.toLocaleString(),
      specialtyGroupName: row.specialtyGroupDisplayName,
      fillableGapCount: row.fillableGapCount.toLocaleString(),
      unfillableGapCount: row.unfillableGapCount.toLocaleString()
      /* eslint-enable sort-keys */
    }
  });

  return (
    <div className="ecd-export__wrapper">
      <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      <TopSpecialtiesTable
        tableData={wizardContext.gapsBySpecialtyData}
        fillableGapsPrimary={wizardContext.fillableGapsPrimary}
        unfillableGaps={wizardContext.unfillableGaps}
        isExport={true}
      />
      <br />
      {wizardContext.addGraphDetails && (
        <div className="ecd-export__table">
          <h2 className="qes-dashboard-tile__title ecd-export__head">{title + " Details"}</h2>
          <Waffles<TopSpecialtiesDrillInData>
            columns={columnConfig}
            data={tableData}
            fullWidth={true}
            loading={tableData.length === 0}
            testId="ecd-export-top-specialties__table"
          />
        </div>
      )}
    </div>
  );
}

export default TopSpecialtiesByGapExport;